var map = {
	"./articles/email.png": 17,
	"./articles/hnc.jpg": 50,
	"./articles/hnc_banner.jpg": 51,
	"./articles/logo_facebook.png": 18,
	"./articles/logo_linkedin.png": 19,
	"./articles/logo_twitter.png": 20,
	"./articles/spinneret_arrival.jpg": 52,
	"./articles/straw_prototype.jpg": 53,
	"./bg.jpg": 15,
	"./bg.mp4": 28,
	"./bg.webm": 27,
	"./cellophax/cellophax_banner.jpg": 83,
	"./cellophax/straws.jpg": 84,
	"./cofounders.jpg": 35,
	"./email.svg": 34,
	"./group.jpg": 85,
	"./headshots/alam.jpg": 29,
	"./headshots/hearty.jpg": 30,
	"./headshots/lumb.jpg": 31,
	"./headshots/vandeven.jpg": 32,
	"./logo.svg": 14,
	"./materials/cellophax.jpg": 36,
	"./materials/derivatives.jpg": 37,
	"./materials/hnc.jpg": 38,
	"./materials/hnc_banner.jpg": 39,
	"./materials/hydrogel.jpg": 40,
	"./materials/other.jpg": 41,
	"./materials/treeyon.jpg": 42,
	"./treeyon/product_item_fabric.jpg": 86,
	"./treeyon/product_item_fishing_net_lines.jpg": 87,
	"./treeyon/product_item_yarn.jpg": 88,
	"./treeyon/treeyon_banner.jpg": 89,
	"./world.svg": 33
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16;